export default {
  header: {
    title: '💛 Dar propina al equipo',
    subtitle: 'El 100% va para el equipo',
  },
  buttons: {
    other: 'Otro',
    none: 'Ninguna',
  },
  summary_label: 'Propina',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} es el importe máximo de propina',
      },
    },
  },
};
